export default __webpack_public_path__ + "static/media/app-store.99d124b5.svg";